import React from "react";
import WatermarkedPdfRedactionWorkspace from "./WatermarkedPdfRedactionWorkspace";

export default function WatermarkedPdfRedactionScreen(props) {
  return <WatermarkedPdfRedactionWorkspace {...props} layout="screen" />;
}
